import React, {useState, useCallback} from 'react';
import {setSelectedMixEffect} from 'actions/index.js';

export const useEffects = ({trackOrGroup}) => {
    let [effects, setEffects] = useState(trackOrGroup.effects);

    const onDeleteEffect = useCallback((effect) => {
        setEffects([... trackOrGroup.effects]);

        let sub = trackOrGroup.subSequence;
        trackOrGroup.sequencerEngine.dispatch(
            setSelectedMixEffect(sub.id, trackOrGroup.id, undefined, "AUDIO_FX", undefined));
    }, [trackOrGroup, setEffects]);

    return {onDeleteEffect, effects};
};
